import { useEffect, useState } from 'react';
import { useDepsMatchingCallbackRef } from 'src/utils/react/deps-matching-callback-ref.hook';
import { apiGetJourneyDocumentInsights } from 'src/utils/journeyApi';
import { TimePeriodParam } from '../constants';
import { DocumentInsight } from './constants';

type Params = {
  journeyUuId?: string;
  nodeIds?: number[];
  filters?: {
    session_uuid?: string;
    disable_session_grouping?: boolean;
    time_period?: TimePeriodParam;
  };
};

export const useJourneyDocumentInsights = ({ journeyUuId, nodeIds, filters }: Params) => {
  const [fetching, setFetching] = useState(true);
  const [documentInsights, setDocumentInsights] = useState<DocumentInsight[]>([]);

  const onFetchJourneyDocumentInsightsRef = useDepsMatchingCallbackRef(
    (response: any) => {
      setDocumentInsights(response.insights as DocumentInsight[]);
      setFetching(false);
    },
    [journeyUuId, nodeIds, filters]
  );

  useEffect(() => {
    const fetchJourneyDocumentInsights = async () => {
      setFetching(true);
      if (journeyUuId && nodeIds) {
        const response = await apiGetJourneyDocumentInsights(
          journeyUuId,
          nodeIds,
          // @ts-ignore
          filters?.session_uuid || undefined,
          filters?.disable_session_grouping || false,
          filters?.time_period || undefined
        );
        onFetchJourneyDocumentInsightsRef.current &&
          onFetchJourneyDocumentInsightsRef.current(response, [journeyUuId, nodeIds, filters]);
      }
    };
    fetchJourneyDocumentInsights();
  }, [journeyUuId, nodeIds, filters]);

  return { fetching, documentInsights };
};
